module.exports = __webpack_public_path__ + "img/c1.9c3c2771.png";